import NotificationTabs from './NotificationTabs';

export default NotificationTabs;
